import React from "react";
import {
  Edit,
  DisabledInput,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";

import KioskTitle from "./kioskTitle";

const KioskEdit = ({ permissions, ...props }) => (
  <Edit title={<KioskTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput source="title" label="Nom" />
      <TextInput source="serialno" label="Borne identifier" />
      <ReferenceInput label="Station" source="stationid" reference="stations">
        <SelectInput optionText="location" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);

export default KioskEdit;



// WEBPACK FOOTER //
// ./src/components/kioskEdit.js